import { NormalizedTransfer } from '../types/transfers';
import Helper from '@wetransfer/transfer/helper';
import Browser from '@wetransfer/transfer/modules/concorde-browser';

export function makeTransferEventData({
  transfer,
  mode,
  isForwardedTransfer,
  currentSize,
}: {
  transfer: NormalizedTransfer;
  isForwardedTransfer: boolean;
  currentSize: number;
  mode: 'upload' | 'download';
}) {
  return {
    size: currentSize,
    forward: isForwardedTransfer,
    password: Boolean(transfer.password),
    expiry: transfer.expiry,
    file_types: Array.from(
      new Set(transfer.items.map(({ file }) => file.type))
    ),
    mode,
    type: transfer.type,
    item_count: transfer.items.length,
    app_type: Browser.isMobile ? 'mobile' : 'web',
    receiver_count: transfer.recipients.length,
    // Is it the first time a user is uploading?
    ...(Helper.getWTSent() === 0 && {
      days_since_first_upload: Helper.getDaysSinceFirstVisit(),
    }),
  };
}
